// src/hooks/useApiClient.js
//
// Returns the right data client for the current account:
//   - live accounts -> services/api.js
//   - demo accounts -> services/demoApi.js (demo-safe shapes, no live writes)
//
// Mirrors useRevenueApi, but for shared surfaces like the notification centre
// that need the same demo/live split without being revenue-specific.
import { useAuth } from "../contexts/AuthContext";
import apiService from "../services/api";

export default function useApiClient() {
  const { user } = useAuth();
  if (!user?.isDemo) return apiService;
  // Lazy-require so the separate demo axios instance is only pulled in for a
  // demo account.
  // eslint-disable-next-line global-require
  return require("../services/demoApi").default;
}
